import { toUserModel } from "~/helpers/utilHelper";
import { combineReducers } from "redux";
import {
  GET_AUTH_USER_OK,
  GET_AUTH_USER_ERR,
  LOGOUT_USER_OK,
} from "./actionTypes";
import { TLoginState } from "./types";
import { TAction } from "~/types/global";


/********** LOGIN **********/

const defaultLoginState: TLoginState = {
  user: null,
  userError: null,
  isAuth: null,
}

const Login = (state = defaultLoginState, action: TAction) => {
  switch (action.type) {
    case GET_AUTH_USER_OK:
      return {
        ...state,
        isAuth: true,
        user: toUserModel(action.payload.response.user),
      };
    case GET_AUTH_USER_ERR:
      return {
        ...state,
        isAuth: false,
        userError: action.payload.error,
      };
    case LOGOUT_USER_OK:
      return {
        ...state,
        user: null,
      }
    default:
      return state;
  }
}

export default combineReducers({
  Login,
})
